import { atom } from "recoil"

export enum RoomsSortingType {
  SORT_IN_PARTICIPANTS,
  SORT_IN_NEWER,
}

export enum CheckingRoomPasswordStateType {
  NONE,
  SUCCESS,
  FAILURE,
}

const waitingRoomState = atom({
  key: 'waitingRoomState',
  default: {
    roomsSorting: RoomsSortingType.SORT_IN_PARTICIPANTS,
    isOpenedCreatingRoom: false,
    isOpenedEnteringSecretRoom: false,
    tryingRoomId: '',
    checkingRoomPasswordState: CheckingRoomPasswordStateType.NONE,
    tryingEncryptedPassword: '',
  }
});

export default waitingRoomState;